import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { relativeDate, date } from '../formatters';
import { Icons } from '../icons';

const dateIcons = {
  service: Icons.Tool,
  cert: Icons.FileText,
  job: Icons.Calendar
};

export default function KeyDateList({ dates, compact = false }) {
  return (
    <div className={`keydate-list ${compact ? 'compact' : ''}`}>
      {dates.map((item) => (
        <div className="keydate-row" key={item.id}>
          <div className={`date-icon date-${item.type}`}>
            <SafeIcon icon={dateIcons[item.type] || Icons.Calendar} />
          </div>
          <div className="keydate-copy">
            <div className="keydate-heading">
              <strong>{item.title}</strong>
              <span className={`date-tag date-${item.type}`}>
                {item.relative || relativeDate(item.date)}
              </span>
            </div>
            <p>{date(item.date)}</p>
            {!compact && <small>{item.detail}</small>}
          </div>
          <SafeIcon icon={Icons.ChevronRight} className="row-chevron" />
        </div>
      ))}
    </div>
  );
}